import React from 'react';

const BreadcrumbSeparator = () => {
  return <div className="w-px-5 h-px-5 bg-primary rounded-circle" />;
};

export default BreadcrumbSeparator;
